/**
 * @flow
 */
import SignIn from './SignIn'
import SignUp from './SignUp'
import NotFound from './NotFound'
import ForgotPassword from './ForgotPassword'
import {ROUTE} from '../../settings'
import Home from './Home';

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false
    },
    leftSidebar: {
      show: false,
      mode: "close"
    }
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false
    },
    navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const commonRoutes = [
  {path: '/', component: Home, settings, exact: true},
  {path: ROUTE.SIGN_IN, component: SignIn, settings},
  {path: ROUTE.SIGN_UP, component: SignUp, settings},
  {path: ROUTE.NOT_FOUND, component: NotFound, settings},
  {path: ROUTE.FORGOT_PASSWORD, component: ForgotPassword, settings},
];

export default commonRoutes;
